import { validationErrorMessages } from '../../utility/constants';
import { FormConfig } from '../../models/dynamic.model';
import { ValidatorPattern } from '../../utility/validators.pattern';

export const consigneeConfig: FormConfig = {
  fields: [
    {
      id: 'countryCode',
      type: 'input',
      label: 'Country',
      required: true,
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 50,
      requiredError: 'Country is required',
    },
    {
      id: 'name',
      type: 'input',
      label: 'Name',
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      required: true,
      requiredError: 'Name is required',
      isCheckForMaxValue: true,
    },
    {
      id: 'companyName',
      type: 'input',
      label: 'Company Name',
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      required: true,
      requiredError: 'Company Name is required',
      isCheckForMaxValue: true,
    },
    {
      id: 'address_1',
      type: 'input',
      label: 'Address Line 1',
      required: true,
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      requiredError: 'Address Line 1 is required',
      isCheckForMaxValue: true,
    },
    {
      id: 'address_2',
      type: 'input',
      label: 'Address Line 2',
      required: false,
      noInitialWhiteSpace: true,
      maxValue: 126,
      isCheckForMaxValue: true,
    },
    {
      id: 'city',
      type: 'input',
      label: 'City',
      required: true,
      minValue: 3,
      maxValue: 50,
      noInitialWhiteSpace: true,
      requiredError: 'City is required',
      minError: 'Invalid City entered',
      isCheckForMaxValue: true,
    },
    {
      id: 'state',
      required: false,
      requiredError: 'State/Province/Region is required',
      type: 'input',
      maxValue: 5,
      label: 'State',
      noInitialWhiteSpace: true,
    },
    {
      id: 'zipCode',
      minError: 'Postal code must be between 4 and 10 characters',
      type: 'input',
      label: 'Postal Code',
      requiredError: 'Postal Code is required',
      maxValue: 10,
      minValue: 4,
      noInitialWhiteSpace: true,
      isCheckForMaxValue: true,
      patternError:'Invalid Postal Code'
    },
    {
      id: 'email',
      type: 'input',
      pattern: ValidatorPattern.Email_Validator,
      label: 'Email',
      maxValue: 50,
      required: false,
      requiredError: 'Valid Email is required',
      emailPatternError: validationErrorMessages.invalidEmailEntered,
      noInitialWhiteSpace: true,
    },
    {
      id: 'phone',
      type: 'input',
      label: 'Phone',
      noInitialWhiteSpace: true,
      required: false,
      requiredError: 'Phone Number is required',
    },
    {
      id: 'taxId',
      label: 'Tax ID',
      type: 'input',
      noInitialWhiteSpace: true,
      maxValue: 126,
      isCheckForMaxValue: true,
      requiredError: 'Tax ID is mandatory for all non-document shipments going to Brazil',
    },
    {
      id: 'id',
      label: 'Id',
      type: 'input',
    },
  ],
};

export const shipperConfig: FormConfig = {
  fields: [
    {
      id: 'countryCode',
      type: 'input',
      label: 'Country',
      required: false,
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 50,
      requiredError: 'Country is required',
    },
    {
      id: 'name',
      type: 'input',
      label: 'Name',
      noInitialWhiteSpace: true,
      minValue: 1,
      maxValue: 126,
      requiredError: 'Name is required',
      isCheckForMaxValue: true,
    },
    {
      id: 'companyName',
      type: 'input',
      label: 'Company Name',
      noInitialWhiteSpace: true,
      maxValue: 126,
      requiredError: 'Company Name is required',
      isCheckForMaxValue: true,
    },
    {
      id: 'address_1',
      type: 'input',
      label: 'Address Line 1',
      required: false,
      noInitialWhiteSpace: true,
      maxValue: 126,
      requiredError: 'Address Line 1 is required',
    },
    {
      id: 'address_2',
      type: 'input',
      label: 'Address Line 2',
      required: false,
      noInitialWhiteSpace: true,
      maxValue: 126,
    },
    {
      id: 'city',
      type: 'input',
      label: 'City',
      required: false,
      minValue: 3,
      maxValue: 50,
      noInitialWhiteSpace: true,
      requiredError: 'City is required',
      minError: 'Invalid City entered',
    },
    {
      id: 'state',
      type: 'input',
      label: 'State',
      required: false,
      maxValue: 5,
      noInitialWhiteSpace: true,
      requiredError: 'State/Province/Region is required',
    },
    {
      id: 'zipCode',
      type: 'input',
      label: 'Postal Code',
      noInitialWhiteSpace: true,
      minValue: 4,
      maxValue: 10,
      isCheckForMaxValue: true,
      requiredError: 'Postal Code is required',
      minError: 'Postal code must be between 4 and 10 characters',
       patternError: 'Invalid Postal Code',
    },
    {
      id: 'email',
      type: 'input',
      label: 'Email',
      required: false,
      noInitialWhiteSpace: true,
      maxValue: 50,
      pattern: ValidatorPattern.Email_Validator,
      requiredError: 'Valid Email is required',
      emailPatternError: validationErrorMessages.invalidEmailEntered,
    },
    {
      id: 'phone',
      type: 'input',
      label: 'Phone',
      required: false,
      noInitialWhiteSpace: true,
    },
    {
      id: 'id',
      type: 'input',
      label: 'Id',
    },
  ],
};
